import axios from 'axios';
import publicRoutes from '../App'
// https://ntactapi.brainymed.com/ntact/ --prof
// https://ntactapidev.brainymed.com/ntact/ dev
// Base instance of Axios
let errorHandler;

export const setErrorHandler = (handler) => {
  errorHandler = handler;
}
const api = axios.create({
  baseURL: 'https://ntactapi.brainymed.com/ntact',
  headers: {
    'Content-Type': 'application/json',
  },
});
const getTokenFromParams = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('allow');  
};
// Add a request interceptor to include the token                   
api.interceptors.request.use(
  (config) => {
    const tokenFromParams = getTokenFromParams();
    if (tokenFromParams) {   
      config.headers.Authorization = `Bearer ${tokenFromParams}`;
    } else {
      const token = sessionStorage.getItem('accessToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;  // <-- Always return config here
  },
  (error) => {
    return Promise.reject(error);
  } 
);
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      // Handle Unauthorized (401) - Possible expired token
      if (status === 401) {
        console.warn("Unauthorized! Redirecting to login...");
        sessionStorage.removeItem("accessToken"); // Clear token
        window.location.href = "/"; // Redirect user to login
      } 
      // 🔑 Show modal for 500 errors
      else if (status === 500 && errorHandler) {
        errorHandler("We’re having trouble reaching our services right now. Please try again later or contact your system administrator.");
      }
    } 
    // 🔑 Network errors (no response)
    else if (errorHandler) {
      errorHandler("Network Error! Please check your internet connection.");
    }

    return Promise.reject(error);
  }
);
export default api;
